import {FormikProps} from "formik";
import React, {FC, memo} from "react";
import {Form, InputNumber} from "antd";
import {blue} from "@ant-design/colors";
import {SettingInput} from "../../../generated/graphql";
import i18n from "../../../services/i18n";
import {createInputHelpers} from "../../../helpers/createInputHelpers";
import {isDefined} from "../../../helpers/typeScriptHelpers";
import Button from "../../../views/Button/Button";

type DefaultVatProps = {
    formikProps: FormikProps<SettingInput>;
    style?: React.CSSProperties;
};

export const getLabel = (value: number, labelAtFront?: boolean) => {
    const valueInPercent = Number(value * 100).toFixed(2);
    const valueInPercentWithoutDecimal = valueInPercent.replace(".00", "");

    if (labelAtFront) {
        return `${valueInPercentWithoutDecimal}%`;
    }

    return `${valueInPercentWithoutDecimal}%`;
};

export const defaultVatOptions = [
    {
        value: 0.2,
        label: getLabel(0.2),
    },
    {
        value: 0.19,
        label: getLabel(0.19),
    },
    {
        value: 0.07,
        label: getLabel(0.07),
    },
    {
        value: 0.081,
        label: getLabel(0.081),
    },
    {
        value: 0,
        label: getLabel(0),
    },
];

const DefaultVat: FC<DefaultVatProps> = ({formikProps, style}) => {
    const {help, validateStatus, handleBlur} = createInputHelpers(formikProps);
    const {values, setFieldValue} = formikProps;

    // const getLabel = (value: number, labelAtFront?: boolean) => {
    //     const valueInPercent = Number(value * 100).toFixed(2);
    //     const valueInPercentWithoutDecimal = valueInPercent.replace(".00", "");

    //     if (labelAtFront) {
    //         return `${valueInPercentWithoutDecimal}%`;
    //     }

    //     return `${valueInPercentWithoutDecimal}%`;
    // };

    // const defaultVatOptions = [
    //     {
    //         value: 0.2,
    //         label: getLabel(0.2),
    //     },
    //     {
    //         value: 0.19,
    //         label: getLabel(0.19),
    //     },
    //     {
    //         value: 0.07,
    //         label: getLabel(0.07),
    //     },
    //     {
    //         value: 0.081,
    //         label: getLabel(0.081),
    //     },
    //     {
    //         value: 0,
    //         label: getLabel(0),
    //     },
    // ];

    const handleChange = (value: number | null) => {
        console.group("handleChange");
        console.log("value", value);
        console.groupEnd();
        if (value === null) {
            setFieldValue("defaultVat", undefined);
        } else {
            setFieldValue("defaultVat", value);
        }
    };

    return (
        <div style={style}>
            <Form.Item
                label={i18n.containers.settings.SettingsApp.sections.finances.fields.defaultVat.label()}
                help={help("defaultVat")}
                validateStatus={validateStatus("defaultVat")}
                required
            >
                <InputNumber
                    onChange={handleChange}
                    onBlur={handleBlur("defaultVat")}
                    value={
                        isDefined(values.defaultVat)
                            ? values.defaultVat
                            : undefined
                    }
                    style={{width: "100%"}}
                    min={0}
                    max={1}
                    step={0.01}
                    formatter={(value) => `${getLabel(value ?? 0, true)}`}
                    parser={(value) => Number(value?.replace("%", "")) / 100}
                />
            </Form.Item>
            <div style={{display: "flex", gap: "10px", marginTop: -15}}>
                {defaultVatOptions.map((option) => (
                    <Button
                        key={option.value}
                        onClick={() => handleChange(option.value)}
                        style={{
                            width: "100%",
                            borderColor:
                                values.defaultVat === option.value
                                    ? "unset"
                                    : blue[3],
                            color:
                                values.defaultVat === option.value
                                    ? "white"
                                    : blue[5],
                        }}
                        size="small"
                        block
                        type={
                            values.defaultVat === option.value
                                ? "primary"
                                : "default"
                        }
                    >
                        {option.label}
                    </Button>
                ))}
            </div>
        </div>
    );
};

export default memo(DefaultVat);
